import { Validation } from './Validation';
import CustomerJson, { validateWorkshopCustomerJson, validateWorkshopCustomerJsonAddNew, } from "./CustomerJson";
import { WorkshopBookingStatus } from "./WorkshopBookingStatus";
import SepaMandateJson, { validateSepaMandate } from "./SepaMandateJson";
import InvoiceInfoJson from "./InvoiceInfoJson";

export default interface WorkshopBookingJson {
   ID: number | null,

   /**
    * Kunden für den gebucht wurde.
    */
   customer: CustomerJson;

   /**
    * Freitextfeld für Krankheiten, Besonderheiten etc.
    */
   remarks: string;

   /**
    * Status der Buchung.
    */
   state: WorkshopBookingStatus;

   /**
    * Titel des ausgewaehlten Preises.
    */
   selectedPriceTitle: string;

   /**
    * Anmerkungen des ausgewaehlten Preises.
    */
   selectedPriceRemarks: string;

   /**
    * Preis für diesen Kurs in Eurocent der als Anzahlung fällig ist. 
    */
   priceDeposit: number;

   /**
    * Preis  für diesen Kurs  Eurocent der nicht als Anzahlung fällig ist. 
    * Der Gesamtpreis des Kurses pro Teilnehmer ist priceDeposit + priceNonDeposit
    */
   priceNonDeposit: number;

   /**
    * Kosten die bei einer Stornierung anfallen in Eurocent.
    */
   cancellationFee: number;

   /**
    * Stornierungsbedingungen.
    */
   cancellationRemarks: string;

   /**
    * Datum und Uhrzeit zu der gebucht wurde.
    */
   bookingDateTime: string;

   /**
    * SEPA-Lastschriftmandat für die Zahlung. Kann auch null sein, wenn eine Bar oder Rechnungszahlung gewünscht ist.
    */
   sepaMandate: SepaMandateJson | null;

   /**
     * Rechnungsinformationen wie Rechnungsnummer.
     */
   invoiceInfos: InvoiceInfoJson[] | null;
}

export function validateWorkshopBookingJsonManagementAdd(item: WorkshopBookingJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateString("remarks", 500)
      .validateUsingFunction("customer", validateWorkshopCustomerJson)
      .validateDate("bookingDateTime")
      .validateUsingFunction("sepaMandate", validateSepaMandate, true)
      .validateNonEmptyString("selectedPriceTitle", 100)
      .validateString("selectedPriceRemarks", 500)
      .validateInteger("priceDeposit", 0, null, false)
      .validateInteger("priceNonDeposit", 0, null, false)
      .validateInteger("cancellationFee", 0)
      .validateString("cancellationRemarks", 500)
      .finish();
}

export function validateWorkshopBookingJsonManagement(item: WorkshopBookingJson) {
   return new Validation(item)
      .validateInteger("ID", 0)
      .validateString("remarks", 500)
      .validateUsingFunction("customer", validateWorkshopCustomerJson)
      .validateDate("bookingDateTime")
      .validateUsingFunction("sepaMandate", validateSepaMandate, true)
      .validateNonEmptyString("selectedPriceTitle", 100)
      .validateString("selectedPriceRemarks", 500)
      .validateInteger("priceDeposit", 0, null, false)
      .validateInteger("priceNonDeposit", 0, null, false)
      .validateInteger("cancellationFee", 0)
      .validateString("cancellationRemarks", 500)
      .finish();
}
export function validateWorkshopBookingJsonBookingForm(item: WorkshopBookingJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateString("remarks", 500)
      .validateUsingFunction("customer", validateWorkshopCustomerJsonAddNew)
      .validateEquals("state", WorkshopBookingStatus.requested)
      .validateDate("bookingDateTime")
      .validateUsingFunction("sepaMandate", validateSepaMandate, true)
      .validateNonEmptyString("selectedPriceTitle", 100)
      .validateString("selectedPriceRemarks", 500)
      .validateInteger("priceDeposit", 0, null, false)
      .validateInteger("priceNonDeposit", 0, null, false)
      .validateInteger("cancellationFee", 0)
      .validateString("cancellationRemarks", 500)
      .finish();
}